import button from "@/views/drag-drop-pages/img/button.png";
import section from "@/views/drag-drop-pages/img/card.png";
import category from "@/views/drag-drop-pages/img/category.png";
import column from "@/views/drag-drop-pages/img/column.png";
import custom_chart from "@/views/drag-drop-pages/img/custom_chart.png";
import daterange from "@/views/drag-drop-pages/img/daterange.png";
import field_list from "@/views/drag-drop-pages/img/field_list.png";
import image from "@/views/drag-drop-pages/img/image.png";
import metric from "@/views/drag-drop-pages/img/ribbon.svg";
import dropdown from "@/views/drag-drop-pages/img/switch.svg";
import datepicker from "@/views/drag-drop-pages/img/date_input.svg";
import row from "@/views/drag-drop-pages/img/row.png";
import table from "@/views/drag-drop-pages/img/table.png";
import tile_list from "@/views/drag-drop-pages/img/tile_list.png";
import trend from "@/views/drag-drop-pages/img/trend.png";
import progress from "@/views/drag-drop-pages/img/progress.png";
import { DISPLAY_ELEMENT_MESSAGE_KEY } from "@/static/global-variables";

const IMAGES = {
  button,
  section,
  category,
  column,
  custom_chart,
  datepicker,
  daterange,
  dropdown,
  field_list,
  image,
  metric,
  row,
  table,
  tile_list,
  trend,
  progress
};

const DRAGGABLE = [
  {
    id: 100,
    name: "section",
    icon: "section",
    label: "Section",
    messageKey: "DISP_EL_SECTION",
    modal: "add-card-modal",
    dropEffect: "move"
  },
  {
    id: 200,
    name: "table",
    icon: "table",
    label: "Table",
    messageKey: "DISP_EL_TABLE",
    modal: "add-table-modal",
    dropEffect: "move"
  },
  {
    id: 300,
    name: "fieldlist",
    icon: "field_list",
    label: "Field List",
    messageKey: "DISP_EL_FIELD_LIST",
    modal: "add-field-list-modal",
    dropEffect: "move"
  },
  {
    id: 400,
    name: "trend",
    icon: "trend",
    label: "Trend",
    messageKey: "DISP_EL_TREND",
    modal: "add-trend-chart-modal",
    dropEffect: "move"
  },
  {
    id: 600,
    name: "progress",
    icon: "progress",
    label: "Progress",
    messageKey: "DISP_EL_PROGRESS",
    modal: "add-progress-chart-modal",
    dropEffect: "move"
  },
  {
    id: 700,
    name: "metric",
    icon: "metric",
    label: "Metric",
    messageKey: DISPLAY_ELEMENT_MESSAGE_KEY.METRIC_HIGHLIGHT,
    modal: "add-metric-modal",
    dropEffect: "move"
  },
  {
    id: 800,
    name: "dropdown",
    icon: "dropdown",
    label: "Dropdown",
    messageKey: DISPLAY_ELEMENT_MESSAGE_KEY.DROPDOWN,
    modal: "add-dropdown-modal",
    dropEffect: "move"
  },
  {
    id: 900,
    name: "datepicker",
    icon: "datepicker",
    label: "Datepicker",
    messageKey: DISPLAY_ELEMENT_MESSAGE_KEY.DATE_PICKER,
    modal: "add-datepicker-modal",
    dropEffect: "move"
  }
];

export { DRAGGABLE, IMAGES };
